<div id="chartContainer2" *ngIf="total"></div>
<div id="chartContainer" *ngIf="!total"></div>